import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { CommonUtil } from './../util/common-util';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Constant } from './../constant';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  private apiPath = '/company';
  public companyCode: string;
  public companyName$;

  constructor(
    private router: Router,
    public auth: AuthService,
    private commonUtil: CommonUtil,
    private activatedRoute: ActivatedRoute,
  ) {
    //this.companyCode = this.activatedRoute.snapshot.params['code'];
    //this.companyCode = localStorage.getItem(Constant.lsCompanyCode);
    this.companyName$ = this.commonUtil.companyName$;
  }

  // Keep existing document and list pages on their original header layout.
  get isEventOperationPage(): boolean {
    const path = this.router.url.split(/[?#]/, 1)[0];
    return /^\/(?:myevent-operation\/[^/]+(?:\/(?:guest-attendance|survey))?|myevent-detail\/[^/]+\/attendance(?:\/qr-poster)?|guest\/(?:register|manage)\/[^/]+|attendance\/[^/]+\/[^/]+|event-survey\/[^/]+)\/?$/.test(path);
  }

  ngOnInit() {
    this.updateCompanyCode();

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateCompanyCode();
      });
  }

  private extractCompanyCodeFromUrl(): string | null {
    const url = this.router.url; // 例: /login/abc

    const match = url.match(/\/(?:login|signup)\/([^\/\?]+)/);
    return match ? match[1] : null;
  }

  private updateCompanyCode() {
    const storedCompanyName = localStorage.getItem(Constant.lsCompanyName);
    const isLoggedIn = this.auth.loggedIn.value || !!storedCompanyName;

    if (isLoggedIn) {
      this.companyCode = localStorage.getItem(Constant.lsCompanyCode);
      if (storedCompanyName) {
        this.commonUtil.setCompanyName(storedCompanyName);
      } else if (this.companyCode) {
        this.getOrgName();
      }
      return;
    }

    const codeFromUrl = this.extractCompanyCodeFromUrl();
    const isAuthPage = /^\/(login|signup)(\/|$)/.test(this.router.url);

    if (codeFromUrl) {
      this.companyCode = codeFromUrl;
    } else if (!isAuthPage) {
      this.companyCode = localStorage.getItem(Constant.lsCompanyCode);
    } else {
      this.companyCode = null;
      this.commonUtil.setCompanyName('');
    }

    if (this.companyCode) {
      this.getOrgName();
    }
  }

  onLogout() {
    if (!this.commonUtil.checkOnline()) {
      return;
    }
    this.auth.signOut();
  }

   // ロゴ押下でダッシュボードに遷移
   onDashboard() {
    if (!this.auth.loggedIn || !this.commonUtil.checkOnline()) {
      return;
    }

    this.router.navigate(['/map']);
  }
  onOrganizationAccount() {
    if (!this.auth.loggedIn || !this.commonUtil.checkOnline()) {
      return;
    }

    this.router.navigate(['/account']);
  }

  onOrganizationAbout(){
    if (!this.auth.loggedIn || !this.commonUtil.checkOnline()) {
      return;
    }

    this.router.navigate(['/overview']);

  }
  onAccountAbout(){
    if (!this.auth.loggedIn || !this.commonUtil.checkOnline()) {
      return;
    }

    this.router.navigate(['/profile']);

  }
  onMasterSettings(){
    if (!this.auth.loggedIn || !this.commonUtil.checkOnline()) {
      return;
    }

    this.router.navigate(['/master']);

  }

  getOrgName() {
    const options = this.auth.createApiHeaderBeforeLogin();
    this.commonUtil
      .apiGet(this.apiPath + '/info/' + this.companyCode, options)
      .then(res => {
        if (res.status === Constant.OK) {
          //this.companyName = res.data.name;
          this.commonUtil.setCompanyName(res.data.name);
          console.log(this.commonUtil.companyName$)
        }
      })
      .catch(err => {
        this.commonUtil.debug().log(err);
      });
  }
}
